import React, { useContext, useRef } from "react";
import "./homeget.css";
import { MdOutlineMailOutline } from "react-icons/md";
import { FiPhone } from "react-icons/fi";
import { CiLocationOn } from "react-icons/ci";
import wp from "../photos/wp.png";
import fb from "../photos/fb.png";
import instagram from "../photos/in.png";
import { LanguageContext } from "../settings/LanguageContext";
import emailjs from "@emailjs/browser";
import tiktok from "../photos/tiktok.png"


const Homeget = () => {
  const { lang } = useContext(LanguageContext);
  const formRef = useRef(null);

const sendEmail = async (e) => {
  e.preventDefault();
  const button = e.target.querySelector("button");
  button.disabled = true; // prevent multiple clicks

  try {
    await emailjs.sendForm(
      "service_c49o0vv",
      "template_pwtra5b",
      formRef.current,
      "VHyyrBmncbuS5gFPg"
    );
    alert(lang === "EN" ? "Message sent!" : "Сообщение отправлено!");
    formRef.current.reset();
  } catch (error) {
    console.error(error);
    alert(lang === "EN" ? "Failed to send message 😕" : "Не удалось отправить сообщение 😕");
  } finally {
    button.disabled = false;
  }
};

  return (
    <div className="main-contactus">
      <div className="homeget-container">
        <h4 className="homeget-title">
          {lang === "EN" ? "Get In Touch" : "Свяжитесь с нами"}
        </h4>
        <p className="homeget-text-ready">
          {lang === "EN"
            ? "Ready to start your project? Contact us today and let's discuss how we can help bring your vision to life."
            : "Готовы начать проект? Свяжитесь с нами сегодня, и мы обсудим, как можем воплотить вашу идею в жизнь."}
        </p>

        <div className="homeget-display">
          {/* LEFT SIDE — UNCHANGED */}
          <div className="homeget-contact">
            <h5 className="homeget-contactinfo">
              {lang === "EN" ? "Contact Information" : "Контактная информация"}
            </h5>

            <div className="homeget-contactdiv">
              <div className="homeget-icon-container">
                <MdOutlineMailOutline className="homeget-email-icon" />
              </div>
              <div className="homeget-text">
                <span className="homeget-emaill">
                  {lang === "EN" ? "Email us" : "Эл. почта"}
                </span>
                <a
                  href="mailto:info@memorymakerarmenia.com"
                  className="homeget-email"
                >
                  info@memorymakerarmenia.com
                </a>
              </div>
            </div>

            <div className="homeget-contactdiv">
              <div
                className="homeget-icon-container"
                id="contact-container-color"
              >
                <FiPhone className="homeget-email-icon" />
              </div>
              <div className="homeget-text">
                <span className="homeget-emaill">
                  {lang === "EN" ? "Call us" : "Позвоните нам"}
                </span>
                <a
                  href="https://wa.me/37493106810"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  (+374)93106810
                </a>
              </div>
            </div>

            <div className="homeget-contactdiv">
              <div
                className="homeget-icon-container"
                id="contact-container-color3"
              >
                <CiLocationOn className="homeget-email-icon" />
              </div>
              <div className="homeget-text">
                <span className="homeget-emaill">
                  {lang === "EN" ? "Office" : "Офис"}
                </span>
                <a
                  href="https://www.google.com/maps?q=Republic+Square,+Yerevan,+Armenia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="homeget-email"
                >
                  Armenia, Yerevan
                </a>
              </div>
            </div>

            <div className="social-media">
              <a href="https://wa.me/37493106810" target="_blank" rel="noopener noreferrer">
                <img src={wp} alt="WhatsApp" />
              </a>
              <a
                href="https://www.facebook.com/ToursinArmeniaTourGuideinArmenia"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={fb} alt="Facebook" />
              </a>
              <a
                href="https://www.instagram.com/memory_maker_travel_armenia/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagram} alt="Instagram" />
              </a>

              <a
                href="https://www.tiktok.com/@memory_maker_armenia?_r=1&_t=ZS-93yW6Hm1EhD"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={tiktok} alt="tiktok" />
              </a>

            </div>
          </div>

          {/* RIGHT SIDE — EMAIL FORM */}
          <div className="homeget-message">
            <h5 className="homeget-sendmessage">
              {lang === "EN" ? "Send us a message" : "Отправьте нам сообщение"}
            </h5>

            <form ref={formRef} onSubmit={sendEmail} className="homeget-inputs">
              <div className="homeget-inputes">
                <div className="homeget-name">
                  {lang === "EN" ? "Name*" : "Имя*"}
                </div>
                <input
                  type="text"
                  name="user_name"
                  className="homeget-inp"
                  placeholder={lang === "EN" ? "Your Name" : "Ваше имя"}
                  required
                />
              </div>

              <div className="homeget-inputes">
                <div className="homeget-name">
                  {lang === "EN" ? "Email*" : "Эл. почта*"}
                </div>
                <input
                  type="email"
                  name="user_email"
                  className="homeget-inp"
                  placeholder="your@email.com"
                  required
                />
              </div>

              <div className="homeget-inputes">
                <div className="homeget-name">
                  {lang === "EN" ? "Message*" : "Сообщение*"}
                </div>
                <textarea
                  name="message"
                  className="homeget-inp3"
                  placeholder={
                    lang === "EN"
                      ? "Tell us about your project"
                      : "Расскажите о вашем проекте"
                  }
                  required
                />
              </div>

              <div className="homeget-sendmessage">
                <button type="submit" className="btn-homegetmessage">
                  {lang === "EN" ? "Send Message" : "Отправить"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homeget;
